import { MouseEventHandler } from 'react'

import { BackButton } from '@/components/widget-components'
import { useBuySellStore } from '@/reducers/transactionReducer'

export const UseEthInfo = ({ onHide }: { onHide: MouseEventHandler }) => {
  const latestV2Quote = useBuySellStore.use.latestV2Quote()
  const gasFees = latestV2Quote?.breakdown.gasFee ?? 0
  const ethAmount = gasFees * 2

  return (
    <div
      data-testid="container-eth-info"
      className="top-0 bottom-0 left-0 right-0 absolute dark:bg-stone-900 bg-cloud overflow-y-scroll p-5 z-10"
    >
      <BackButton
        data-testid="btn-eth-info-back"
        aria-label="Go back"
        onClick={onHide}
      >
        &#x27f5;
      </BackButton>
      <div data-testid="container-eth-info-content">
        <div
          data-testid="container-eth-info-text"
          className="pl-[15px] text-[15px] leading-none"
        >
          <p data-testid="text-eth-info-description">
            For an additional ${ethAmount.toFixed(2)}, PayTrie will send $
            {gasFees.toFixed(2)} worth of ETH with this transaction.
          </p>
          <p data-testid="text-eth-info-recommendation">
            This is highly recommended for new users or newly generated wallets.
          </p>
          <p data-testid="text-eth-info-optional">
            This is an optional feature and is not required if you are sending
            to an exchange address
          </p>
        </div>
      </div>
    </div>
  )
}
